import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetScrapFinanceAccountsService } from "@/features/accounts/scrap-finance/services/get-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useGetScrapFinanceAccountStates } from "@/features/accounts/scrap-finance/hooks/use-get-accounts-states";
import { useContext } from "react";
import { GetScrapFinanceAccountsResponseModel } from "@/features/accounts/scrap-finance/services/get-accounts-model";


export const useGetScrapFinanceAccount = () => {
  const {
    institutionType,
    setInstitutionType,
    scrapFinanceAccounts,
    setScrapFinanceAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useGetScrapFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getScrapFinanceAccountsService = new GetScrapFinanceAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 銀行口座一覧取得
  const getScrapFinanceAccounts = async (
    accountGroupId: string,
    scrapFinanceAccountId?: string,
  ) :Promise<GetScrapFinanceAccountsResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const resScrapFinanceAccounts = await getScrapFinanceAccountsService.getScrapFinanceAccounts({
        account_group_id: accountGroupId,
        ...(scrapFinanceAccountId !== undefined && { scrap_finance_account_id: scrapFinanceAccountId }),
      });
      // 成功時の処理
      setScrapFinanceAccounts(resScrapFinanceAccounts);
      return resScrapFinanceAccounts;
    } catch (error) {
      // エラーハンドリング
      console.log("getFinanceAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    institutionType,
    setInstitutionType,
    scrapFinanceAccounts,
    setScrapFinanceAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
    getScrapFinanceAccounts: errorHandledAsync(getScrapFinanceAccounts, setError),
  };
};
